import api from "../../apis";

export const tiktokLogin = async () => {
  try {
    const response = await api.post("/oauth/tiktok/generate", {});
    return response.data.link;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const tiktokOAuthAPI = async (state, code, scope) => {
  try {
    const response = await api.get(`/oauth/tiktok?state=${state}&code=${code}&scope=${scope}`);
    return response.data.link;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};